/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './addMember.defs.js'
export { main as default } from './addMember.defs.js'
